const selectTitle = document.getElementById('selectTitle');

const showVariant = () => {
  if (!selectTitle) return;

  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  const selectedValues = Array.from(variantSelects.querySelectorAll('fieldset'))
    .map((fieldset) => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    })
    .filter(Boolean);

  selectTitle.textContent = selectedValues.join(' / ');
};

// 初期表示
showVariant();

// 再描画されても対応できるよう、documentにイベント委任
document.addEventListener('change', (e) => {
  if (e.target.matches('variant-selects input[type="radio"]') || (e.target.closest('variant-selects') && e.target.type === 'radio')) {
    showVariant();
  }
});
